import React from 'react'
import NumberFormat from 'react-number-format'
import { DisplayToThaiDateFormatFromString, getBankName } from '../../helpers/texthelper'
import { DocumentDetailModel } from '../../models/documentDetail'
import { MoreInfoComponent } from '../moreInfoComponent'

export const QRCodeInfo: React.FC<{ item: DocumentDetailModel }> = ({ item }) => {
  return (
    <>
      <div className="flex-container">
        <div className="flex-item-left">
          <div className="flex-container-cc">
            <div className="flex-item-cc-left">
              <li>
                <span>{item.paymentMethod.name}</span>{' '}
              </li>
            </div>
          </div>
          <div className="flex-container-cashPayIn-detail">
            <div className="flex-item-detail-left">
              ธนาคาร : <span>{getBankName(item.bankCode)}</span>
            </div>
            <div className="flex-item-detail-right">
              เลขที่บัญชี : <span>{item.accountNo}</span>
            </div>
            <div className="flex-item-detail-left">
              วันที่ฝาก : <span>{DisplayToThaiDateFormatFromString(item.payInDate)}</span>
            </div>
          </div>
          <div className="break-line" style={{ marginLeft: 40 }} />
          <div className="item-detail-remark can-edit-info">
            หมายเหตุ : <span>{item.remarkMoneyType}</span>
          </div>
        </div>
        <div className="flex-item-right amount-right">
          <span>
            <NumberFormat
              thousandsGroupStyle="thousand"
              value={item.paymentAmount}
              prefix=""
              decimalSeparator="."
              displayType="text"
              type="text"
              thousandSeparator={true}
              allowNegative={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
          </span>{' '}
          บาท
        </div>
      </div>
      <MoreInfoComponent item={item}></MoreInfoComponent>
      <hr className="separate-detail"></hr>
    </>
  )
}
